import { render, staticRenderFns } from "./PuncherDetail.vue?vue&type=template&id=04d36282"
import script from "./PuncherDetail.vue?vue&type=script&lang=js"
export * from "./PuncherDetail.vue?vue&type=script&lang=js"
import style0 from "./PuncherDetail.vue?vue&type=style&index=0&id=04d36282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports